@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.pinned {
  width: 100%;
  height: 60px;
  background: var(--default--background-color-22);
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--default--border-color--10);
}

.saving {
  transition: all 200ms ease;
}
